import React from 'react';
import { AccessibilityProps, Picker, StyleProp, StyleSheet, Text, View, ViewStyle } from 'react-native';

import { colors, fonts, scale } from '../Styles';

type Props = AccessibilityProps & {
  style?: StyleProp<ViewStyle>;
  title: string;
  /** The value displayed in the input. */
  selectedValue?: string;
  /** The list of options the user can choose from. */
  options: string[];
  /** Whether or not to display the * to mark as required */
  required?: boolean;
  /** Called when the user selects a new value. */
  onValueChange?: (value: string) => void;
};

/** A controller MNOHS-styled Picker input component that works on the web */
export const MNOHSPicker = (props: Props) => {
  return (
    <View style={props.style} accessible={true}>
      <Text style={styles.title}>
        {props.title} {props.required && <Text style={[styles.title, styles.asterisk]}>*</Text>}
      </Text>
      <Picker
        style={styles.dropDownTouchable}
        itemStyle={styles.pickerItem}
        selectedValue={props.selectedValue}
        onValueChange={item => props.onValueChange?.(item)}>
        {props.options.map((option, index) => {
          return <Picker.Item key={`MNOHS-picker-item-${index}`} label={option} value={option} />;
        })}
      </Picker>
    </View>
  );
};

const styles = StyleSheet.create({
  dropDownTouchable: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: colors.grayLight,
    borderRadius: scale(8),
    minHeight: scale(48),
    // iOS Shadowing
    shadowColor: colors.black,
    shadowRadius: 2,
    shadowOpacity: 0.5,
    shadowOffset: { width: 0, height: 2 },
    // Android Shadowing
    elevation: 5,
    appearance: 'none',
    borderWidth: 0,
    fontFamily: 'MontserratRegular',
    paddingLeft: scale(4),
  },
  title: {
    ...fonts.linkedText,
    marginBottom: scale(7.5),
  },
  pickerItem: {
    // not working apparently.
    // github issue: https://github.com/react-native-community/react-native-picker/issues/47
    fontFamily: 'MontserratRegular',
    fontSize: scale(14),
  },
  asterisk: {
    color: colors.science,
  },
});
